"use strict";
var React = require("react");
var { Modal, Button, ButtonToolbar, closeButton } = require("react-bootstrap");
var InventoryItemForm = require("./InventoryItemForm");

var XMLUrlModal = React.createClass({

    render: function() {
        return (
            <Modal id="XMLModal" {...this.props} bsStyle="primary" animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>XML tengill</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Þú getur notað tengilinn hér að neðan til að flytja gögnin þín m.v. skilgreinda síu í Excel. Afritaðu tengilinn hér að neðan og settu inn í gagnatenginu Excel.
                    </p>
                    {(this.props.xmlUrl === '') ?
                        <p className="text-center">
                            <strong>
                                Athuga! Þú ert ekki með neina skilgreinda síu á gögnunum þínum. Til þess að fá tengil þá þarftu fyrst að skilgreina síu.
                            </strong>
                        </p> :
                        <span />
                    }
                    <input type="text" className="form-control input-lg text-center" defaultValue={this.props.xmlUrl} />
                    <div className="text-center">
                        <small >Nánari leiðbeiningar um innflutning í Excel má finna með því að <a href={this.props.xmlUrl} target="_blank">smella hér</a></small>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <ButtonToolbar>
                        <Button className="pull-right" onClick={this.props.onHide}>Loka</Button>
                    </ButtonToolbar>
                </Modal.Footer>
            </Modal>
        );
    }
});

module.exports = XMLUrlModal;



// WEBPACK FOOTER //
// ./app/scripts/ui/Inventory/XMLUrlModal.js